<template>
    <div class="d-flex bd-highlight mb-3">
        <div class="col" style="border-top: 0.125rem solid rgba(1, 153, 209, .5)" v-for="(data,i) in nameList"
             :key="data.title">
            <div class="row d-flex align-items-center" style="height: 15%">
                <p class="dv-card-title" :class="maxRateIndex===i ? 'text-red' : ''">{{ data.title }}</p>
            </div>
            <RateGauge style="height: 50%" :id="data.id" :value="rates[i]"></RateGauge>
            <div class="row d-flex justify-content-around" style="height: 25%">
                <div class="footer-item">
                    <div class="col d-flex flex-column justify-content-center h-100">
                        <div class="row m-auto position-relative h-30">
                            <p class="dv-card-title p1 fix-center">平均响应</p>
                        </div>
                        <div class="row m-auto position-relative h-70 p-2">
                            <p class="footer-number fix-center" style="color: #ea6027">{{ respond[i] }}</p>
                        </div>
                    </div>
                </div>
                <div class="footer-item">
                    <div class="col d-flex flex-column justify-content-center h-100">
                        <div class="row m-auto position-relative h-30">
                            <p class="dv-card-title p1 fix-center">平均处理</p>
                        </div>
                        <div class="row m-auto position-relative h-70 p-2">
                            <p class="footer-number fix-center" style="color: #26fcd8">{{ solve[i] }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import RateGauge from "./charts/RateGauge";
import EmCommonApi from "@/mixin/em/common/api";
import {_getWorkshopCode} from "./CodeToName";

export default {
    name: "AndonRespondRate",
    components: {RateGauge},
    mixins: [EmCommonApi],
    props: {
        code: Number
    },
    data() {
        return {
            names: ['技术', '质量', '设备', '其他'],
            rates: [],
            respond: [],
            solve: [],
            nameList: [],
            fresh: {},

            maxRateIndex: -1
        }
    },
    mounted() {
        this.buildData();
        this.getRemoteData()
        this.fresh = setInterval(() => {
            this.getRemoteData()
        }, 30 * 60 * 1000);
    },
    beforeDestroy() {
        clearInterval(this.fresh)
    },
    methods: {
        buildData() {
            this.nameList = new Array(4).fill(0).map((item, index) => ({
                title: this.names[index] + '安灯',
                id: 'chart' + index
            }))
        },
        getRemoteData() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesAndonTask")}/sithMesAndonTask/typeRate`
            this.$_emApiMixin_post(_api, {
                code: _getWorkshopCode(this.code)
            }, false).then(value => {
                let data = value.data;
                let rateList = [];
                let maxRate = 0;
                if (data.typeRate) {
                    for (let i = 0; i < data.typeRate.length; i++) {
                        let rate = data.typeRate[i];
                        let r = (rate * 100).toFixed(2);
                        let number = Number.parseFloat(r);
                        if (number > maxRate) {
                            maxRate = number;
                            this.maxRateIndex = i;
                        }
                        rateList.push(r);
                    }
                    _this.rates = rateList;
                    _this.respond = data.responseTime;
                    _this.solve = data.finishTime;
                }
            })
        }
    }
}
</script>

<style scoped>
.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.25rem;
    color: white;
    font-weight: 700;
    margin-bottom: 0;
}

.dv-card-title.p1 {
    font-size: 0.65rem;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dv-card-title.p2 {
    font-size: 1.125rem;
    color: #1294fb
}

.footer-item {
    padding: 10% 0;
    box-sizing: border-box;
    width: 45%;
    height: 80%;
    background-color: rgba(6, 30, 93, .7);
    border-radius: 3px;
}

.footer-number {
    text-align: left;
    font-weight: bold;
    font-size: 1.3rem;
}

.fix-center {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
}

.text-red {
    color: #ff546c !important;
}
</style>